export default {
  setLibraryPath({ commit }, path) {
    commit('setLibraryPath', path);
  },
};
